<nx-card class="table-card-viewer">
  <page-list-view-header
    [newSupplier]="new()"
    [title]="headerTitle"
    [(viewChangers)]="viewChangers"
    [menuWantedInMobileView]="true"
    [onlyAddNewButtonWantedInMobileView]="false"
  ></page-list-view-header>

  <div nxRow="">
    <div nxCol="12">
      @if (!viewChangers['calendarView'].show) {
        <div class="aquila-table-custom">
          <aquila-table [rows]="models" [colDefinitions]="colDef" [actionConfig]="actionDef"
            [elementsPerPage]="pageSize"
            [showAsList]="mobile"
          ></aquila-table>
        </div>
      }
      <!--      <ng-container *ngIf="viewChangers['mapView'].show">-->
      <!--        <app-map [models]="mapModels" [startZoom]="8" [markerClickSupplier]="markerClick()" [showYourPosition]="false"></app-map>-->
    <!--      </ng-container>-->
    @if (viewChangers['calendarView'].show) {
      @if (models) {
        <app-gant-chart #gantChartComponent [cookieKey]="GANT_DISTRIBUTOR_FILTER_COOKIE_KEY"
        [options]="options" [models]="models" [service]="service"></app-gant-chart>
      }
    }
  </div>
</div>
</nx-card>


<ng-template #test let-value="value">
  @for (role of value; track role) {
    {{ role }},
  }
</ng-template>


